import * as React from 'react';
import { Button } from '../button/Button';
import { Flex } from './FlexHelpers';

type ShowMorePanelProps = {
    itemIncrement?: number;
    children: React.ReactNode[];
}

export function ShowMorePanel(props:ShowMorePanelProps):JSX.Element
{
    const [showItemCount, setShowItemCount] = React.useState<number>(props.itemIncrement || 10);

    React.useEffect(() => {
        setShowItemCount(props.itemIncrement || 10);
    }, [props.itemIncrement]);

    const nextShowItemCount = Math.min(showItemCount + (props.itemIncrement || 10), props.children.length);   

    return (
        <Flex flexDirection="column" justifyContent="stretch" grow="1">
            {props.children.map((c,i) => {
                if(i < showItemCount)   
                    return c;   
            })}
            {showItemCount < props.children.length &&
                <div style={{ textAlign: 'center', marginTop: '12px' }}>
                    <Button variant="text" 
                        text={`Vis flere (${nextShowItemCount})`}
                        onClick={() => setShowItemCount(showItemCount + (props.itemIncrement || 10))}  
                    />
                </div>
            }
        </Flex>
    );
}